import React from "react";
import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import content from "../content/content.json";

const colVariants = {
  hidden: { opacity: 0, y: 12 },
  visible: (i) => ({
    opacity: 1,
    y: 0,
    transition: { delay: i * 0.1, duration: 0.35, ease: "easeOut" },
  }),
};

const aboutLinks = [
  { label: "What We Stand For", href: "/about#stand-for" },
  { label: "What We Do",        href: "/about#what-we-do" },
  { label: "Our Approach",      href: "/about#approach" },
  { label: "Where We Focus",    href: "/about#focus" },
  { label: "What We Value",     href: "/about#values" },
];

const AboutUs = () => {
  const { capabilityAreas } = content;
  const firstTwo = capabilityAreas.items.slice(0, 2);

  return (
    <motion.div
      className="absolute top-full left-0 w-full h-screen bg-white shadow-lg z-50"
      initial="hidden"
      animate="visible"
      exit="hidden"
    >
      <div className="grid md:grid-cols-3 h-full">

        {/* Left — hero text */}
        <motion.div
          className="bg-[#0f1016] text-white p-10 flex flex-col justify-center h-full"
          custom={0}
          variants={colVariants}
        >
          <p className="text-xs uppercase tracking-[0.2em] text-[#44c4bd] font-semibold mb-4">
            About GEM
          </p>
          <h2 className="text-2xl font-extrabold leading-snug mb-3">
            We Design Systems That Institutions Can Trust
          </h2>
          <p className="text-sm text-white/60 leading-relaxed">
            Building Systems That Hold Under Real Conditions
          </p>
        </motion.div>

        {/* Middle — page section links */}
        <motion.div
          className="bg-[#f5f7fa] p-10 h-full"
          custom={1}
          variants={colVariants}
        >
          <p className="text-[11px] font-bold uppercase tracking-widest text-[#007681] mb-5">
            On This Page
          </p>
          <ul className="space-y-3">
            {aboutLinks.map(({ label, href }) => (
              <li key={label}>
                <Link
                  to={href}
                  className="flex items-center gap-2 text-gray-700 hover:text-[#E4002B] font-medium text-sm transition-colors duration-150 group"
                >
                  <span className="text-gray-300 group-hover:text-[#E4002B] transition-colors">→</span>
                  {label}
                </Link>
              </li>
            ))}
          </ul>
        </motion.div>

        {/* Right — first 2 core capabilities */}
        <motion.div
          className="bg-white p-10 border-l border-gray-100 h-full"
          custom={2}
          variants={colVariants}
        >
          <p className="text-[11px] font-bold uppercase tracking-widest text-[#007681] mb-5">
            Core Capabilities
          </p>
          <div className="space-y-4 mb-5">
            {firstTwo.map((cap) => (
              <Link
                key={cap.id}
                to={cap.href}
                className="flex items-center gap-4 group"
              >
                <img
                  src={cap.image}
                  alt={cap.title}
                  className="w-20 h-14 object-cover rounded-sm flex-shrink-0 group-hover:opacity-90 transition-opacity"
                />
                <span className="text-sm font-semibold text-gray-800 group-hover:text-[#E4002B] transition-colors leading-snug">
                  {cap.title}
                </span>
              </Link>
            ))}
          </div>
          <Link
            to="/capabilities"
            className="text-xs font-semibold text-[#007681] hover:text-[#E4002B] transition-colors flex items-center gap-1"
          >
            View our Core Capabilities →
          </Link>
        </motion.div>

      </div>
    </motion.div>
  );
};

export default AboutUs;
